import { Timestamp, TranslateFunction } from '@griply/types';
import { addDays, format, isSameDay, isSameYear } from 'date-fns';

export type DateSectionLabel = {
  primary: string;
  secondary: string;
};

export const getDateSectionLabel = (
  date: Timestamp,
  today: Timestamp,
  t: TranslateFunction,
): DateSectionLabel => {
  const secondary = format(
    date,
    isSameYear(date, today) ? 'd MMM' : "d MMM ''yy",
  );

  if (isSameDay(date, today)) {
    return { primary: t('general.labels.dates.today'), secondary };
  }

  if (isSameDay(date, addDays(today, 1))) {
    return { primary: t('general.labels.dates.tomorrow'), secondary };
  }

  return { primary: format(date, 'EEE'), secondary };
};
